import React from "react";
import CloseButton from "@/components/button/close-button";
import Text from "@/components/text/text";
// import VenueMap from "@/components/map/venue-map";
import GoogleMap from "@/components/map/google/google-map";
import { useNavigate, useParams } from "react-router-dom";
import { useExplorationStore } from "@/store/explorationStore";
import { useAppStore } from "@/store/appStore";

function ExplorationWindowLayout({ children }: { children: React.ReactNode }) {
  let navigate = useNavigate();
  const prevChatType = useExplorationStore(state => state.prevChatType);
  const setChatType = useAppStore((state) => state.setChatType);

  return (
    <div className="bg-chatpanel">
      <div className="flex justify-between items-center p-[20px]">
        <Text text="chat_tab_exploration" className="text-500" size={18} />
        <CloseButton goBack={false} onClick={() => {
          // reset previous chat type so that home chat will not highlight "exploration" tab
          setChatType(prevChatType);
          navigate("/")
        }} />
      </div>
      {children}
    </div>
  );
}

const ExplorationPage: React.FC = () => {
  const { venueCode } = useParams();
  console.log("ExplorationPage venueCode", venueCode)
  return (
    <ExplorationWindowLayout
      // children={<VenueMap isConstrained={false} />}
      children={<GoogleMap venueCode={venueCode} />}
    ></ExplorationWindowLayout>
  );
};

export default ExplorationPage;
